import { Form, Input, InputNumber, Select, TimePicker } from "antd";
import { DatePicker } from "antd-jalali";
import dayjs from "dayjs";
import { useState } from "react";
import styles from "./SignUpInputs.module.css";
import { Majors } from "../../util/MajorSetter";
import { Genders } from "../../util/GenderSetter";
import { MaritalStatuses } from "../../util/MaritalStatusSetter";
import DesiredPlanSetter, { DesiredPlans } from "../../util/DesiredPlanSetter";
import { IntroducedByList } from "../../util/IntroducedBySetter";
const { Option } = Select;
const SignUpInputs = ({ form }) => {
  const [age, setAge] = useState(form.getFieldValue("age"));
  return (
    <div className={styles.DataContainer}>
      <div className={styles.RightSide}>
        <h2>اطلاعات شخصی</h2>
        <Form.Item
          name="first_name"
          label="نام"
          rules={[
            {
              required: true,
              message: "لطفا نام خود را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="نام خانوادگی"
          rules={[
            {
              required: true,
              message: "لطفا نام خانوادگی خود را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="father_name"
          label="نام پدر"
          rules={[
            {
              required: true,
              message: "لطفا نام پدر خود را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          className={styles.InlineFormItem}
          name="birth_date"
          label="تاریخ تولد"
          rules={[
            {
              required: true,
              message: "لطفا تاریخ تولد خود را وارد کنید!",
            },
          ]}
        >
          <DatePicker
            onChange={() => {
              const age = dayjs(dayjs(), { jalali: true }).diff(
                dayjs(form.getFieldValue("birth_date"), { jalali: true }),
                "years"
              );
              form.setFieldValue("age", age);
              setAge(age);
            }}
            showNow={false}
            style={{ width: "100%" }}
          />
        </Form.Item>
        <Form.Item
          className={styles.InlineFormItem}
          style={{ marginRight: "1rem" }}
          name="age"
          label="سن"
          rules={[
            {
              required: true,
              message: "لطفا سن خود را وارد کنید!",
            },
          ]}
        >
          <InputNumber min={1} max={100} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          className={styles.InlineFormItem}
          name="city_born"
          label="شهر تولد"
          rules={[
            {
              required: true,
              message: "لطفا شهر محل تولد خود را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          className={styles.InlineFormItem}
          style={{ marginRight: "1rem" }}
          name="country_born"
          label="کشور محل سکونت"
          rules={[
            {
              required: true,
              message: "لطفا شهر محل تولد خود را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="job"
          label="شغل"
          rules={[
            {
              required: true,
              message: "لطفا شغل را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="gender"
          label="جنسیت"
          rules={[
            {
              required: true,
              message: "لطفا جنسیت خود را انتخاب کنید!",
            },
          ]}
        >
          <Select placeholder="جنسیت">
            {Genders.map(({ value, text }) => (
              <Option value={value}>{text}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="marital_status"
          label="وضعیت تاهل"
          rules={[
            {
              required: true,
              message: "لطفا وضعیت تاهل خود را انتخاب کنید!",
            },
          ]}
        >
          <Select placeholder="وضعیت تاهل">
            {MaritalStatuses.map(({ value, text }) => (
              <Option value={value}>{text}</Option>
            ))}
          </Select>
        </Form.Item>
        <h2>تحصیلات</h2>
        <Form.Item
          name="major"
          label="رشته تحصیلی"
          rules={[
            {
              required: true,
              message: "لطفا رشته تحصیلی خود را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="education_stage"
          label="مدرک تحصیلی"
          rules={[
            {
              required: true,
              message: "لطفا مدرک تحصیلی خود را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Select placeholder="مدرک تحصیلی">
            {Majors.map(({ value, text }) => (
              <Option value={value}>{text}</Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div className={styles.LeftSide}>
        <h2>اطلاعات تماس</h2>
        <Form.Item
          name="home_number"
          label="شماره تلفن منزل"
          rules={[
            {
              required: true,
              message: "لطفا شماره تلفن منزل خود را وارد کنید!",
            },
          ]}
        >
          <Input
            style={{
              width: "100%",
            }}
          />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label="شماره تلفن همراه"
          rules={[
            {
              required: true,
              message: "لطفا شماره تلفن همراه خود را وارد کنید!",
            },
          ]}
        >
          <Input
            style={{
              width: "100%",
            }}
          />
        </Form.Item>
        {age <= 18 ? (
          <>
            <Form.Item
              name="mother_phone"
              label="شماره تلفن مادر"
              rules={[
                {
                  required: true,
                  message: "لطفا شماره تلفن مادر خود را وارد کنید!",
                },
              ]}
            >
              <Input
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
            <Form.Item
              name="father_phone"
              label="شماره تلفن پدر"
              rules={[
                {
                  required: true,
                  message: "لطفا شماره تلفن پدر خود را وارد کنید!",
                },
              ]}
            >
              <Input
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>{" "}
          </>
        ) : null}
        <Form.Item
          name="address"
          label="آدرس"
          rules={[
            {
              required: true,
              message: "لطفا آدرس خود را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
        <h2>اطلاعات عمومی</h2>

        <Form.Item
          name="desired_plan"
          label="علاقه‌مند به یادگیری کدامیک از برنامه های زبان انگلیسی هستید؟"
          rules={[
            {
              required: true,
              message: "لطفا علاقه‌مندی خود را انتخاب کنید!",
            },
          ]}
        >
          <Select placeholder="برنامه‌های زبان">
            {DesiredPlans.map(({ value, text }) => (
              <Option value={value}>{text}</Option>
            ))}
          </Select>
        </Form.Item>
        <div className={styles.InlineFormContainer}>
          <Form.Item
            className={styles.InlineFormItem}
            name="introduced_by"
            label="از چه طریق با موسسه ما آشنا شدید؟"
            rules={[
              {
                required: true,
                message: "لطفا طریق آشنایی خود با موسسه را انتخاب کنید!",
              },
            ]}
          >
            <Select placeholder="برنامه‌های زبان">
              {IntroducedByList.map(({ value, text }) => (
                <Option value={value}>{text}</Option>
              ))}
            </Select>
          </Form.Item>
          {/* <Form.Item
            className={styles.InlineFormItem}
            style={{ marginRight: "1rem" }}
            name="introducer"
            label="کد معرف:"
          >
            <InputNumber />
          </Form.Item> */}
        </div>
        <div className={styles.InlineFormContainer}>
          <Form.Item
            className={styles.InlineFormItem}
            style={{ width: "33%" }}
            name="learning_experience_years"
            label="چند سال به یادگیری زبان پرداخته اید؟"
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            className={styles.InlineFormItem}
            style={{ marginRight: "1rem", width: "calc(33% - 1.5rem)" }}
            name="former_instructor"
            label="در کجا:"
          >
            <Input />
          </Form.Item>
          <Form.Item
            className={styles.InlineFormItem}
            style={{ marginRight: "1rem", width: "calc(33% - 1.5rem)" }}
            name="former_book"
            label="چه کتابی:"
          >
            <Input />
          </Form.Item>
        </div>
        <Form.Item
          name="about_me"
          label="جمله‌ای درمورد خودتان بنویسید:"
          rules={[
            {
              whitespace: true,
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </div>
    </div>
  );
};

export default SignUpInputs;
